import mapValues from "lodash/mapValues";

const normalizedFilters = (filters) => mapValues(filters, (filter) => {
    filter = { ...filter };
    switch (filter.type) {
        case "datetime":
            filter.type = "date"
            break;
    }
    return filter;
})

export default normalizedFilters;